import React, { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import "../../utils/Style/component/modals.scss";
import { useDispatch, useSelector } from 'react-redux';
import { setShowOverviewDetialsPopup } from '../../features/overviewSlice';
import ProgressBarStatus from '../ProgressBarStatus';
import useDeliveryOrderApi from '../../api/DelivaryOrderApi';
import PortalMap from '../PortalMap';

function OverviewDetailsPopup({ order }) { 
  const dispatch = useDispatch();
  const {GetDriverLocation} = useDeliveryOrderApi();
  const [showMap, setShowMap] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCloseModal = () => {
    dispatch(setShowOverviewDetialsPopup(false));
  };

  const currencySymbol = order?.currency === "USD" ? "$" : "L.L";
  const driverLocation = useSelector(state => state.overview.driverLocation);
  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    return date.toLocaleDateString() + " " + date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit'});
  };

  const normalizedStatus = order?.status?.toLowerCase().trim();

  const statusDescription = [
    { 
      Step: "Order Placed", 
      IsActive: normalizedStatus === "new" ||  normalizedStatus === "new - scheduled", 
      Description: order?.dateCreated && formatDateTime(order.dateCreated) 
    },
    { 
      Step: "Assigned", 
      IsActive: normalizedStatus === "assigned - driver on its way to cashroom" 
        || normalizedStatus === "assigned - driver on its way to user" 
        || normalizedStatus === "assigned - driver on its way to portal",
        Description: order?.dateAssigned && formatDateTime(order.dateAssigned)
    },
    { 
      Step: "Cash Picked Up", 
      IsActive: normalizedStatus === "cash picked up" || 
                normalizedStatus === "cash picked up from cashroom - on its way to user" || 
                normalizedStatus === "cash picked up from user - on its way to portal",
      Description: order?.dateCashedPickup && formatDateTime(order.dateCashedPickup)    
    },
    { 
      Step: "Order Closed", 
      IsActive: normalizedStatus === "order completed", 
      Description: order?.dateCompleted && formatDateTime(order.dateCompleted)
    }
  ];

  const handleShowLocation = async () => {
    setLoading(true);
    try {
      await GetDriverLocation(order.orderID);
      setShowMap(true);
      setValidationError("");
    } catch (error) {
      setValidationError("Failed to fetch driver location. Please try again.");
      setShowMap(false);
    } finally {
      setLoading(false);
    }
  };

  const shouldShowLocation = !["new", "new - scheduled", "cancelled", "order completed"].includes(normalizedStatus);

  const userLocation = order?.userLocation 
  ? {
      lat: parseFloat(order.userLocation.split(',')[0].trim()),
      lng: parseFloat(order.userLocation.split(',')[1].trim())
    }
  : null;

  return (
    <Modal centered show={true} onHide={handleCloseModal} className="overview-details-popup-modal">
      <Modal.Body>
        <div className="mobile-confirmation-modal">
          <div className='close' onClick={handleCloseModal}>X</div>
          <div className="header-overview-popup">
            <div className='title'>Order ID: <span className='orderId-number'>{order?.orderID}</span></div>
          </div>

          <div className='overview-information'>
            <div className='details'>
              <div className='row-details'>
                <div className='label'>Type of order</div>
                <div className='value'>{order?.type}</div>
              </div>
              <div className='row-details'>
                <div className='label'>Client Name</div>
                <div className='value'>{order?.clientFullName}</div>
              </div>
              <div className='row-details'>
                <div className='label'>Amount</div>
                <div className='value'>{currencySymbol} {order?.amount}</div>
              </div>
              <div className='row-details'>
                <div className='label'>Date & Time Order Placed</div>
                <div className='value'>{order?.dateCreated ? formatDateTime(order?.dateCreated) : "-"}</div>
              </div>
              <div className='row-details'>
                <div className='label'>Date & Time Order Completed</div>
                <div className='value'>{order?.dateCompleted ? formatDateTime(order?.dateCompleted) : "-"}</div>
              </div>
              <div className='row-details'>
                <div className='label'>User Address</div>
                <div className='value'>{order?.address}, {order?.eta} {order?.eta <= 1 ? "Minute" : "Minutes"}</div>
              </div>
              <div className='row-details'>
                <div className='label'>Driver Name</div>
                <div className='value'>{order?.driverName}</div>
              </div>
              <div className='row-status'>
                <div className='label'>Status</div>
                <div className='progressBarStatusPopup'>
                  <ProgressBarStatus statusDescription={statusDescription} />
                </div>
              </div>
              {shouldShowLocation && (
                <>
                  <div className='button-details'>
                    <button className='location-btn' onClick={handleShowLocation} disabled={loading}>
                      {loading ? (
                        <Spinner animation="border" role="status" size="sm" />
                      ) : (
                        "Show location"
                      )}
                    </button>
                  </div>
                  {validationError && <div className="error">{validationError}</div>}
                  {showMap && userLocation && (
                    <PortalMap
                      userLocation={userLocation} 
                      driverLocation={driverLocation}
                      zoom={10}
                      handleChangeZoom={() => {}}
                    />
                  )}
                </>
              )}
            </div>
          </div>               
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default OverviewDetailsPopup;
